import { RULES, UNIT_COSTS, LINKS, STRUCTURES } from "./movement.mjs";
import { FRONTLINE } from "./mapgen.mjs";

// Short pre-match tutorial. Pure data + cursor so it is testable under Node; the DOM lives in src/ui.js.
export const PAGES = [
  {
    id: "goal",
    title: "Win the field",
    body: `Destroy the red command base, or lead on score when the rounds run out. ` +
      `You get ${RULES.apPerTurn} AP a turn in Skirmish and ${FRONTLINE.apPerTurn} on Frontline. ` +
      `Moving, firing, building and dropping all spend AP. On big maps, drag the minimap or use the arrow keys to look around.`,
  },
  {
    id: "hexes",
    title: "Read the hexes",
    body: "Plains and roads cost 1 AP. Gold ore pays Phytane. Forest and hills cost 2 AP and give 20% cover; " +
      "forest blocks sight, hills fire down on flat ground. Towns give 30% cover. Mountains and water block movement; " +
      "cross rivers at fords or bridges.",
    legend: true,
  },
  {
    id: "phytane",
    title: "Phytane economy",
    body: `Each turn you collect ${RULES.baseIncome} Phytane from your base, +${RULES.oreIncome} for every ore hex ` +
      `your infantry has claimed, and +${RULES.harvesterIncome} for each harvester parked on ore. ` +
      `Spend it in the Build row: infantry costs ${UNIT_COSTS.infantry}, a tank ${UNIT_COSTS.tank}.`,
  },
  {
    id: "reserves",
    title: "Reserve drops",
    body: `Enemy units you destroy join your reserve tray. Pick one, then tap a cyan hex next to your base ` +
      `to drop it for ${RULES.dropAp} AP. New and dropped units cannot attack on the turn they arrive.`,
  },
  {
    id: "height",
    title: "High ground",
    body: `Grey plateaus stand a level up. Climb by stairs (any unit) or ladders (infantry) for +${LINKS.stairs.extra} AP. ` +
      `Orange jump pads throw infantry and tanks over spike pits for ${RULES.jumpAp} AP and end the move. ` +
      `Firing down from a plateau deals +${RULES.highGround}%.`,
  },
  {
    id: "air",
    title: "Air power",
    body: `Helicopters (tier 2) and jets (tier 3) fly over any terrain and ignore cover. ` +
      `Jets spend a flat ${RULES.sortieAp} AP per sortie. Only infantry, AA batteries and other aircraft can hit them.`,
  },
  {
    id: "defenses",
    title: "Turrets and AA",
    body: `Build a gun turret (${STRUCTURES.turret.cost} Ph) or AA battery in your territory. ` +
      `They fire at the end of the enemy turn at anything they can hit in range. Keep the army under that cover.`,
  },
  {
    id: "research",
    title: "Research",
    body: `Spend Phytane to raise your tech tier. Tier 2 unlocks helicopters, destroyers and AA; ` +
      `tier 3 unlocks jets and battleships. Each tier you lead by is +${RULES.techEdge}% damage.`,
  },
  {
    id: "sea",
    title: "The sea",
    body: `Ships sail only on water. Build a dock on a coastal hex, then launch gunboats, destroyers or a battleship ` +
      `onto the adjacent sea. Infantry cannot shoot ships; tanks, artillery, aircraft and coastal guns can.`,
  },
  {
    id: "go",
    title: "Your first turn",
    body: "The banner above the command bar walks you through it: select, move, attack, end turn. " +
      "Help or ? brings this guide back.",
  },
];

/** Next page index, or null when the tutorial closes. */
export function step(index, action) {
  if (action === "skip" || action === "done") return null;
  if (action === "back") return Math.max(0, index - 1);
  if (action === "next") return index + 1 < PAGES.length ? index + 1 : null;
  return index;
}

const STORAGE_KEY = "iron-command-tutorial";

export function seen(storage) {
  try {
    return (storage ?? globalThis.localStorage)?.getItem(STORAGE_KEY) === "seen";
  } catch {
    return false;
  }
}

export function markSeen(storage) {
  try {
    (storage ?? globalThis.localStorage)?.setItem(STORAGE_KEY, "seen");
  } catch {
    /* private mode */
  }
}
